module.exports = {
	BASE_URL: process.env.REACT_APP_BASE_URL,
	SOCKET_DATA:
		"https://tcrrugj26j.execute-api.ap-south-1.amazonaws.com/default/userConnected",
	EMAIL_URL:
		"https://y9uodp2gkd.execute-api.us-east-1.amazonaws.com/default/sendemail1",
};
